<template>
    <div :class="{ 'add-widget-card': true }" @click="handleClick">
        <icon :icon="['fal', 'layer-plus']"/> &nbsp; Add widget
    </div>
</template>

<script>
    export default {
        name: "AddWidgetCard",
        methods: {
            handleClick() {
                this.$emit('press');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

    .add-widget-card {
        display: flex;
        flex-flow: row;
        background-color: mix(#262C32, #60cf56, 70);
        justify-content: center;
        color: var(--card-font-color);
        border-radius: 4px;
        width: 100%;
        -webkit-column-break-inside: avoid;
        box-shadow: 0px 0px 10px rgb(0,0,0, 0.5);
        padding: 5px 10px 5px 10px;
    }

    .add-widget-card:hover {
        background-color: mix(#262C32, #60cf56, 55);
        cursor: pointer;
    }

</style>